<div class="fb-finish-profile-dialog py-4 px-3 md:px-6 flex flex-col justify-center items-start gap-4">

	<div (click)="dialogRef.close()"
		 class="sticky w-max top-1 left-0 -ml-4 px-2 pt-2 bg-[#D4A373] rounded">
			<span class="material-symbols-outlined cursor-pointer text-white">
				close
			</span>
	</div>
	<h2 class="w-full font-semibold text-[#3c3c3c] text-lg md:text-2xl text-center">
		{{data.productGroup === 'finished' ? 'Size': 'Pantone'}} Guide
	</h2>
	<div class="fb-disclaimer-box flex items-center gap-2">
		<span class="material-symbols-outlined">error</span>
		<p>{{data.sizeProfile.disclaimer}}</p>
	</div>
	<div class="w-full flex flex-col lg:flex-row justify-between items-start gap-4">
		<div *ngIf="data.productGroup === 'finished'" class="w-full">
			<div class="w-full flex justify-between items-center mb-4">
				<h3 class="font-semibold text-[#3c3c3c]">Product Measurements </h3>
				<div class="flex items-center gap-2">
					<span>Inches</span>
					<mat-slide-toggle [(ngModel)]="isCm" color="primary"></mat-slide-toggle>
					<span>Centimeters</span>
				</div>
			</div>
			<table class="w-full border-b border-[#EDEDFD]">
				<tr class="w-full ">
					<th class="bg-[#EDEDFD] text-center p-1">Size</th>
					<ng-container *ngFor="let size of data.sizeProfile.sizeProfileOptionList; let i = index">
						<th class="bg-[#EDEDFD] text-center p-1">
							{{size.label}}
						</th>
					</ng-container>
				</tr>
				<ng-container *ngFor="let size of newSizeArray">
					<tr>
						<td class="bg-[#EDEDFD] text-center p-0.5 capitalize">{{size.label.toLowerCase()}}</td>
						<ng-container *ngFor="let number of size.guideNumber">
							<td class="text-center p-0.5">
								{{isCm ?  (number * 2.54).toFixed() : number.toFixed() }}
							</td>
						</ng-container>
					</tr>
				</ng-container>
			</table>
		</div>
		<img class="object-contain"
			 [ngClass]="this.data.productGroup === 'finished' ? 'finish-width' : 'pantone-width'"
			 [src]="data.sizeProfile.image" [alt]="data.sizeProfile.displayName">
	</div>
</div>
